import { Component } from '@angular/core';
import { FooterLinksComponent } from './footer-links/footer-links.component';
import { LegalLinksComponent } from './legal-links/legal-links.component';

@Component({
  selector: 'ac-footer',
  templateUrl: './footer.component.html',
  standalone: true,
  imports: [
    FooterLinksComponent,
    LegalLinksComponent,
  ],
})
export class FooterComponent {}
